import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EntrySummaryStateService } from './entry-summary-state.service';

// Default (user-side) implementation: POST v2/line-items/bulk-delete via the root state service.
// Declared before the abstract token so the decorator's `useClass` reference is initialized.
@Injectable({ providedIn: 'root' })
export class UserLineItemsBulkDeleteStrategy {
  constructor(private entrySummaryStateService: EntrySummaryStateService) {}

  public bulkDelete(itemIds: number[]): Observable<never> {
    return this.entrySummaryStateService.bulkDeleteLineItems(itemIds);
  }
}

/**
 * Narrow write-routing token for the shared bulk-delete UI (#12865).
 * The broker page overrides it in component providers (visible to template descendants) to hit
 * the management endpoint — overriding the whole EntrySummaryStateService there is unsafe
 * because the page needs the root instance's forceDataReload$.
 */
@Injectable({ providedIn: 'root', useClass: UserLineItemsBulkDeleteStrategy })
export abstract class LineItemsBulkDeleteStrategy {
  public abstract bulkDelete(itemIds: number[]): Observable<never>;
}
